module.exports = __webpack_public_path__ + "img/mechanic_1.fd2e3539.png";